import { Building2 } from 'lucide-react';

import { Empty } from '../../../components/ui';
import { useT } from '../../../i18n';

/**
 * Màn cổng tenant mở bằng tài khoản không thuộc tenant nào (nhân sự nền tảng
 * đang "Xem giao diện tenant" — ADR-UI-0012 mục 9).
 *
 * Không phải lỗi, không phải thiếu quyền: chỉ là ở đây không có dữ liệu của ai
 * để hiện. Chỉ đường sang đúng chỗ xem được.
 */
export function KhongCoTenant() {
  const { t } = useT();
  return (
    <div className="rounded-lg border border-default bg-surface shadow-sm">
      <Empty icon={Building2} title={t('baoMat.khongCoTenant')} description={t('baoMat.khongCoTenantMo')} />
    </div>
  );
}
